import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.getExpense.views.expenseReportDetailSummaryLoader`

export default defineMessages({
  loadingLabel: {
    id: `${scope}.loadingLabel`,
    defaultMessage: 'Loading expense report details...',
  },
})
